import React, { useState } from "react";
import axios from "axios";
import ENDPOINT from "../../context/EndPoint";
import { useDispatch } from "react-redux";

const AddEbook = ({handelClose,reload}) => {
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    book_name: "",
    description: "",
    course_url: "",
    batch_id: "",
    image: null,
    title:'',
  });


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle file selection
  const handleFileChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch({type:'LOADING'})

    if (!formData.image) {
      dispatch({type:'ERROR',payload:"Please select an image."});
      return;
    }

    const data = new FormData();
    data.append("book_name", formData.book_name);
    data.append("title", formData.title);

    data.append("description", formData.description);
    data.append("course_url", formData.course_url);
    data.append("batch_id", formData.batch_id);
    data.append("image", formData.image);

    try {
      const response = await axios.post(ENDPOINT+
        "insert-book.php",
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if(response.data.status === 'success'){
        setFormData({...formData, book_name: "", description: "", course_url: "", batch_id: "", image: null, title:'' });
        dispatch({type:'DONE_LOADING'})
        handelClose(); 
        reload()

      }
      else{
        dispatch({type:'ERROR',payload:response.data.message});
      }
    } catch (error) {
      dispatch({type:'ERROR',payload:error.message});
    }
  };

  return (
    <div className="container mt-5">
      <h2>Add eBook</h2>
      
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-3">
          <label className="form-label">Book Name</label>
          <input
            type="text"
            className="form-control"
            name="book_name"
            value={formData.book_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            className="form-control"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <div className="mb-3">
          <label className="form-label">Course URL</label>
          <input
            type="url"
            className="form-control"
            name="course_url"
            value={formData.course_url}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Batch ID</label>
          <input
            type="number"
            className="form-control"
            name="batch_id"
            value={formData.batch_id}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Upload Image</label>
          <input
            type="url"
            name="image"
            className="form-control"
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Upload eBook
        </button>
      </form>
    </div>
  );
};

export default AddEbook;
